import { useEffect, useState } from 'react';

import { FiltersDef } from './Filters';
import invariant from 'tiny-invariant';

import Button from '@cobliteam/ui/components/Button';
import DropdownMenu from '@cobliteam/ui/components/DropdownMenu';
import Menu from '@cobliteam/ui/components/Menu';
import Icon from '@cobliteam/ui/icons';

import type { FiltersProps, IFiltersDef, TFilterKeys } from '../types';

const DataTableFilters = ({ filtersDef, onChangeFilter, filtersOptions, limitOfFilters = 50 }: FiltersProps) => {
  invariant(filtersDef, 'data is not defined on DataTableFilters');
  invariant(onChangeFilter, 'onChangeFilter is not defined on DataTableFilters');

  // get filters from data
  const allFilters = FiltersDef.filter((filter) => filtersDef?.some((f) => f.key === filter.key)).sort((a, b) => {
    const indexA = filtersDef.findIndex((f) => f.key === a.key);
    const indexB = filtersDef.findIndex((f) => f.key === b.key);
    return indexA - indexB;
  });

  // get showed filters
  const limited: TFilterKeys[] | undefined = allFilters?.slice(0, limitOfFilters).map((item) => item.key);

  // state to show filters
  const [showFilters, setShowFilters] = useState<TFilterKeys[] | undefined>(limited);

  // get filters to render
  const renderFilters = allFilters?.filter((filter) => showFilters?.includes(filter.key));

  // get filters to render on dropdown
  const renderFiltersDropdown = allFilters?.filter((filter) => !showFilters?.includes(filter.key));

  const onClick = (filter: IFiltersDef) => {
    setShowFilters((prev) => {
      if (!prev?.includes(filter.key)) return prev && [...prev, filter.key];
      return prev;
    });
  };

  useEffect(() => {
    setShowFilters(limited);
  }, [JSON.stringify(limited)]);

  return (
    <>
      {renderFilters?.map((filter) => {
        const options = filtersOptions?.find((f: any) => f.key === filter.key)?.options;
        return (
          <div key={filter.key} className='flex animate-slide-down-and-fade'>
            {filter.component({
              filters: filtersDef,
              onChangeFilter,
              options: options,
            })}
          </div>
        );
      })}
      {renderFiltersDropdown?.length ? (
        <DropdownMenu>
          <DropdownMenu.Trigger asChild>
            <Button variant='outlined' size='condensed' color='secondary' startIcon={<Icon name='filter' />}>
              Filtros
            </Button>
          </DropdownMenu.Trigger>
          <DropdownMenu.Content align='start'>
            <DropdownMenu.Header>Adicionar Filtros</DropdownMenu.Header>
            <DropdownMenu.Separator />
            {renderFiltersDropdown.map((filter) => (
              <Menu.Item key={filter.key} onClick={() => onClick(filter)}>
                <Menu.Icon icon={filter.icon} />
                <Menu.Label>{filter.name}</Menu.Label>
              </Menu.Item>
            ))}
          </DropdownMenu.Content>
        </DropdownMenu>
      ) : null}
    </>
  );
};

export default DataTableFilters;
